type CardInput = {
  id: string
  startMin: number
  endMin: number
}

type OverlapResult = Record<string, { leftPercent: number; widthPercent: number }>

export function calcOverlapLayout(cards: CardInput[]): OverlapResult {
  if (!cards || cards.length === 0) return {}

  const sorted = [...cards].sort((a, b) => a.startMin - b.startMin)

  const groups: CardInput[][] = []
  let currentGroup = [sorted[0]]

  for (let i = 1; i < sorted.length; i++) {
    const maxEnd = Math.max(...currentGroup.map((c) => c.endMin))
    if (sorted[i].startMin < maxEnd) {
      currentGroup.push(sorted[i])
    } else {
      groups.push(currentGroup)
      currentGroup = [sorted[i]]
    }
  }
  groups.push(currentGroup)

  const layoutMap: Record<string, { column: number; totalColumns: number }> = {}
  for (const group of groups) {
    const columns: CardInput[] = []
    for (const card of group) {
      let placed = false
      for (let col = 0; col < columns.length; col++) {
        const lastInCol = columns[col]
        if (card.startMin >= lastInCol.endMin) {
          columns[col] = card
          layoutMap[card.id] = { column: col, totalColumns: 0 }
          placed = true
          break
        }
      }
      if (!placed) {
        layoutMap[card.id] = { column: columns.length, totalColumns: 0 }
        columns.push(card)
      }
    }
    const totalColumns = columns.length
    for (const card of group) {
      layoutMap[card.id].totalColumns = totalColumns
    }
  }

  return Object.entries(layoutMap).reduce<OverlapResult>((acc, [id, { column, totalColumns }]) => {
    acc[id] = {
      leftPercent: (column / totalColumns) * 100,
      widthPercent: (1 / totalColumns) * 100,
    }
    return acc
  }, {})
}
